// src/components/layout/Sidebar.js
import React from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// =================================================================
//   CORRECTED: All icons are now in a single, clean import block
// =================================================================
import {
  faTachometerAlt,
  faUsers,
  faUserTie,
  faMobileAlt,
  faChartLine,
  faCreditCard,
  faBell,
  faUserShield,
  faFileInvoiceDollar, // Icon for Balances
  faUndo,
  faUserSecret,              // Icon for Refunds
  faUserCog, 
} from '@fortawesome/free-solid-svg-icons';

import './Sidebar.css'; // Import the CSS file once

// Navigation items configuration
const navItems = [
  {
    type: 'link',
    to: '/dashboard',
    icon: faTachometerAlt,
    text: 'Dashboard',
  },
  { type: 'sectionHeader', text: 'Management' },
  {
    type: 'link',
    to: '/users',
    icon: faUsers,
    text: 'Users',
  },
  {
    type: 'link',
    to: '/customers',
    icon: faUserTie,
    text: 'Customers',
  },
  {
    type: 'link',
    to: '/devices',
    icon: faMobileAlt,
    text: 'Devices',
  },

{
    type: 'link',
    to: '/agents', // Links to the new agent list view
    icon: faUserSecret,
    text: 'View Agents', // Clear, distinct name
  },
  
 {
    type: 'link',
    to: '/agents/manage', // Links to your original management page
    icon: faUserCog,
    text: 'Manage Agents', // Clear, distinct name
  },

  {
    type: 'link',
    to: '/role-management',
    icon: faUserShield,
    text: 'Role Management',
  },
  {
    type: 'link',
    to: '/role-assignment', // Corrected path
    icon: faUserTie,
    text: 'Role Assignment',
  },
  { type: 'divider' },
  { type: 'sectionHeader', text: 'Operations' },
  {
    type: 'link',
    to: '/sales',
    icon: faChartLine,
    text: 'Sales',
  },
  {
    type: 'link',
    to: '/payments',
    icon: faCreditCard,
    text: 'Payments',
  },
  {
    type: 'link',
    to: '/balances',
    icon: faFileInvoiceDollar,
    text: 'Customer Balances',
  },
  {
    type: 'link',
    to: '/refunds',
    icon: faUndo,
    text: 'Refunds Log',
  },
  {
    type: 'link',
    to: '/notifications',
    icon: faBell,
    text: 'Notifications',
  },
];

function Sidebar() {
  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <h2>Admin Panel</h2>
      </div>
      <ul className="sidebar-nav">
        {navItems.map((item, index) => {
          if (item.type === 'sectionHeader') {
            return (
              <li key={`header-${index}`} className="nav-section-header">
                {item.text}
              </li>
            );
          }
          if (item.type === 'divider') {
            return <li key={`divider-${index}`} className="nav-divider"></li>;
          }
          return (
            <li key={item.to + index}>
              <NavLink
                to={item.to}
                className={({ isActive }) =>
                  isActive ? 'nav-link active' : 'nav-link'
                }
              >
                {item.icon && (
                  <FontAwesomeIcon icon={item.icon} className="nav-icon" />
                )}
                <span className="nav-text">{item.text}</span>
              </NavLink>
            </li>
          );
        })}
      </ul>
    </aside>
  );
}

export default Sidebar;